import React from 'react';
import { CurrencyUtils, SharedUtils, TranslationUtils } from '../../utils';
import { ReceiptLineSummary } from './ReceiptLineSummary';
import { OccupancyCounts, OccupancyKeys } from '../../types/occupancy';
import { TripAdjustmentResponse } from 'guest-data-types-ts-lib';

interface ReceiptLineOccupancyProps {
    preview: TripAdjustmentResponse;
    occupancy_details?: { initialOccupancy: OccupancyCounts | null; occupancyCounts: OccupancyCounts | null };
    locale: string;
}

export const ReceiptLineOccupancy: React.FC<ReceiptLineOccupancyProps> = (props) => {
    const { preview, occupancy_details, locale } = props;
    const { delta } = preview;

    // @ts-ignore
    const { occupancyCounts, initialOccupancy } = occupancy_details;
    const change_request: { [key: string]: number } = {
        [OccupancyKeys.ADULTS]: (occupancyCounts?.adults.count as number) - (initialOccupancy?.adults.count as number),
        [OccupancyKeys.CHILDREN]: (occupancyCounts?.children.count as number) - (initialOccupancy?.children.count as number),
    };

    if (OccupancyKeys.PETS in occupancyCounts) {
        change_request[OccupancyKeys.PETS] = (occupancyCounts?.pets.count as number) - (initialOccupancy?.pets.count as number);
    }

    const { adults, children, pets } = change_request;
    const slugRemoved = TranslationUtils.get('payment_form_removed');
    const slugAdded = TranslationUtils.get('payment_form_added');
    const shouldShowPets = pets != 0;
    return (
        <>
            {pets
                ? shouldShowPets && (
                      <ReceiptLineSummary
                          summaryTitle={`${SharedUtils.getSlugOccupancy('pets', pets < 0 ? pets * -1 : pets)} ${
                              pets < 0 ? slugRemoved : slugAdded
                          }`}
                          summaryValue={CurrencyUtils.formatCurrency(delta.total, delta.currency)}
                          currency={delta.currency}
                          locale={locale}
                      />
                  )
                : null}
            {adults != 0 && (
                <ReceiptLineSummary
                    summaryTitle={`${SharedUtils.getSlugOccupancy('adults', adults < 0 ? adults * -1 : adults)} ${
                        adults < 0 ? slugRemoved : slugAdded
                    }`}
                    summaryValue={CurrencyUtils.formatCurrency(0, delta.currency)}
                    currency={delta.currency}
                    locale={locale}
                />
            )}
            {children != 0 && (
                <ReceiptLineSummary
                    summaryTitle={`${SharedUtils.getSlugOccupancy('children', children < 0 ? children * -1 : children)} ${
                        children < 0 ? slugRemoved : slugAdded
                    }`}
                    summaryValue={CurrencyUtils.formatCurrency(0, delta.currency)}
                    currency={delta.currency}
                    locale={locale}
                />
            )}
            <hr className={'detail-separator'} />
        </>
    );
};
